import { createReducer } from './utils.ts';
import { SNACK_SET } from './constants.ts';
import { AlertState, Action } from '../types/state';

const defaultState: AlertState = {
  snack: { open: false, message: '', severity: 'success' },
};

export const reducer = createReducer(defaultState, {
  [SNACK_SET]: handleSnackSet,
});

function handleSnackSet(state: AlertState, action: Action<unknown>): AlertState {
  const payload = action.payload as { snack: AlertState['snack'] } | undefined;
  return { ...state, snack: payload?.snack || state.snack };
}

export function setSnackAlert(snack: AlertState['snack']) {
  return async (dispatch: (action: Action<unknown>) => void) => {
    dispatch({
      type: SNACK_SET,
      payload: { snack },
    });
  };
}
